import React, {useContext} from "react";
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import ProjectDropdown from "../ProjectDropdown";
import {useWindowWidth} from "../hooks";
import DetailedProjectNavigation from "../DetailedProjectNavigation";
import {RenderPaymentSchedule} from "../RenderPaymentSchedule";
import {isSocialProject} from "../../../../utils/pages";
import './ProjectPaymentSchedule.scoped.scss';

const ProjectPaymentSchedule = () => {
  const {project, paymentSchedule} = useContext(DetailedProjectContext);
  const isMobile = useWindowWidth();
  const isSocial = isSocialProject(project);

  return (
    <div>
      {isMobile ?
        <ProjectDropdown header={isSocial ? "График выплат" : "График погашения"}>
          <RenderPaymentSchedule paymentSchedule={paymentSchedule} />
        </ProjectDropdown>
        : <>
          <div className="detailed-project__header">
            <DetailedProjectNavigation/>
          </div>
          <div className="project-payment-schedule__content">
            <RenderPaymentSchedule paymentSchedule={paymentSchedule}/>
          </div>
        </>}
    </div>
  );
};

export default ProjectPaymentSchedule;
